<template>
  <div id="wrapper">
    <nhan-su-side-bar index="4"></nhan-su-side-bar>
    <div id="content-wrapper">
      <div id="picklistmenu_fluid" class="container-fluid">
        <div class="row">
          <div class="col-3">
            <b-table
              id="picklist-menu-table"
              bordered
              head-variant="dark"
              small
              striped
              hover
              responsive
              selectable
              select-mode="single"
              @row-selected="onRowSelected"
              table-variant="light"
              :fields="fields"
              :items="picklistmenus"
            >
              <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <i class="fa fa-check" aria-hidden="true"></i>
                  <!-- <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span> -->
                </template>
                <template v-else>
                  <!-- <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span> -->
                </template>
              </template>
              <template v-slot:cell(pickListName)="data">
                <textarea
                  id="textarea"
                  style="background-color: transparent;
                border: 0px; resize: none;"
                  class="form-control"
                  disabled
                  :value="data.item.pickListName"
                />
                <!-- <p contenteditable="false">{{ data.item.pickListName }}</p> -->
              </template>
            </b-table>
          </div>
          <div class="col-5">
            <form @submit.prevent="addItem" class="form-inline mb-3">
              <div class="form-group mr-3" style="width: calc(100% - 101px)">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Tên danh mục"
                  v-model="added_item_name"
                  style="width: 100%"
                />
              </div>
              <button class="btn btn-info" style="width:85px;" type="submit">
                <i class="fas fa-plus"></i> Thêm
              </button>
            </form>
            <b-table
              id="picklist-table"
              bordered
              head-variant="dark"
              hover
              striped
              small
              responsive
              table-variant="light"
              :fields="fieldPicklists"
              :items="picklists"
            >
              <!-- selectable
              select-mode="single" -->
              <template v-slot:cell(pickListValue)="data">
                <input
                  :id="'picklistvalue_' + data.item.id"
                  name="picklistvalue"
                  type="text"
                  class="form-control"
                  :value="data.item.pickListValue"
                  required
                  @change="updateItem(data, $event)"
                />
              </template>
              <template v-slot:cell(sortOrder)="data">
                <input
                  :id="'sortorder_' + data.item.id"
                  name="sortorder"
                  type="text"
                  class="form-control"
                  style="text-align: end"
                  :value="data.item.sortOrder"
                  required
                  @change="updateItem(data, $event)"
                />
              </template>
              <template v-slot:cell(deleted)="data">
                <b-button
                  @click.prevent="deleteItem(data)"
                  variant="outline-danger"
                >
                  <i class="fas fa-trash"></i
                ></b-button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NhanSuSideBar from "../components/NhanSu/NhanSuSideBar";

export default {
  name: "PicklistMenu",
  components: {
    NhanSuSideBar,
  },
  data() {
    return {
      fields: [
        {
          key: "selected",
          label: "#",
          tdClass: "align-middle text-center",
          thClass: "align-middle text-center",
          // thStyle: { width: "50px !important" },
          class: "selected_column",
        },
        {
          key: "pickListName",
          label: "Loại danh mục",
          thStyle: { height: "49px" },
          thClass: "align-middle text-center",
          class: "picklistname_column",
        },
      ],
      fieldPicklists: [
        {
          key: "pickListValue",
          label: "Danh mục",
          thStyle: { "text-align": "center", height: "49px" },
          thClass: "align-middle",
          class: "picklistvalue_column",
        },
        {
          key: "sortOrder",
          label: "Thứ tự sắp xếp",
          thStyle: {
            "text-align": "center",
            height: "49px",
            // "max-width": 0,
            // overflow: "hidden",
            // "text-overflow": "ellipsis",
            // "white-space": "nowrap",
          },
          thClass: "align-middle",
          class: "sortorder_column",
        },
        {
          key: "deleted",
          label: "",
          tdClass: "align-middle text-center",
          thStyle: {
            height: "49px",
          },
          thClass: "align-middle",
          class: "deleted_column",
        },
      ],
      added_item_name: "",
      picklistmenus: [],
      picklists: [],
      selected_type: null,
    };
  },
  methods: {
    initData(picklistmenus) {
      this.picklistmenus = picklistmenus;
    },
    onRowSelected(item) {
      if (item.length > 0) {
        this.selected_type = item[0].pickListType;
        axios
          .get(`/api/picklist/${item[0].pickListType}`)
          .then((res) => (this.picklists = res.data));
      } else {
        this.selected_type = null;
        this.picklists = [];
      }
    },
    addItem() {
      if (this.selected_type == null) return;
      if (!(this.added_item_name && this.added_item_name.length)) {
        this.$toast.error("Please enter category!", "Error", {
          timeout: 2000,
        });
      } else {
        var isItemExist = this.picklists.filter(
          (picklist) => picklist.pickListValue == this.added_item_name
        );
        if (isItemExist.length > 0)
          this.$toast.error("Category already exists!", "Error", {
            timeout: 2000,
          });
        else {
          axios
            .post("/api/Picklist", {
              PickListType: this.selected_type,
              PickListValue: this.added_item_name,
              SortOrder:
                this.picklists.length <= 0
                  ? 1
                  : this.picklists[this.picklists.length - 1].sortOrder + 1,
            })
            .then((res) => {
              this.picklists.push(res.data);
              this.added_item_name = "";
              this.$toast.success("Add successfully!", "Success", {
                timeout: 2000,
              });
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Error", { timeout: 3000 });
              this.added_item_name = "";
            });
        }
      }
    },
    updateItem(data, event) {
      var new_item_name = event.target.value;
      if (!(new_item_name && new_item_name.length)) {
        this.$toast.error(
          "Please enter " +
            (event.target.name == "picklistvalue"
              ? "category!"
              : "sort order!"),
          "Error",
          { timeout: 3000 }
        );
        event.target.value =
          event.target.name == "picklistvalue"
            ? data.item.pickListValue
            : data.item.sortOrder;
      } else {
        if (event.target.name == "picklistvalue") {
          var isItemExist = this.picklists.filter(
            (item) =>
              item.pickListValue.toLowerCase() ===
                new_item_name.toLowerCase() && item.id != data.item.id
          );
          if (isItemExist.length > 0) {
            this.$toast.error("Category already exists!", "Error", {
              timeout: 2000,
            });
            event.target.value = data.item.pickListValue;
            return;
          }
        }
        axios
          .put("/api/Picklist", {
            id: data.item.id,
            pickListValue:
              event.target.name == "picklistvalue" ? new_item_name : null,
            sortOrder:
              event.target.name == "sortorder" ? parseInt(new_item_name) : null,
          })
          .then((res) => {
            this.$toast.success("Update successfully!", "Success", {
              timeout: 3000,
            });
            event.target.name == "picklistvalue"
              ? (this.picklists[data.index].pickListValue = new_item_name)
              : (this.picklists[data.index].sortOrder = new_item_name);
          })
          .catch((err) => {
            this.$toast.error(err.response.data, "Error", { timeout: 3000 });
            event.target.value = data.item.pickListValue;
          });
      }
    },
    deleteItem(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`api/Picklist/${data.item.id}`)
                .then((res) => {
                  this.picklists.splice(data.index, 1);
                  this.$toast.success("Delete successfully!", "Success", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.all([axios.get("/api/PicklistMenu")]).then(
      axios.spread((picklistmenu) => {
        next((vm) => vm.initData(picklistmenu.data));
      })
    );
  },
  autoheight_textarea() {
    return 1;
  },
};
</script>
<style>
#picklistmenu_fluid table#picklist-table tbody,
#picklistmenu_fluid table#picklist-menu-table tbody {
  display: block;
  overflow: auto;
  max-height: calc(100vh - 220px);
}
#picklistmenu_fluid table#picklist-table thead,
#picklistmenu_fluid table#picklist-table tbody tr,
#picklistmenu_fluid table#picklist-menu-table thead,
#picklistmenu_fluid table#picklist-menu-table tbody tr {
  display: table;
}
#picklistmenu_fluid table#picklist-table thead,
#picklistmenu_fluid table#picklist-table tbody,
#picklistmenu_fluid table#picklist-menu-table thead,
#picklistmenu_fluid table#picklist-menu-table tbody {
  width: 100%;
}
#picklistmenu_fluid table#picklist-table thead tr,
#picklistmenu_fluid table#picklist-table tbody tr,
#picklistmenu_fluid table#picklist-menu-table thead tr,
#picklistmenu_fluid table#picklist-menu-table tbody tr {
  width: 100%;
}
#picklistmenu_fluid table#picklist-table tr .picklistvalue_column {
  width: auto;
  min-width: 200px;
}
#picklistmenu_fluid table#picklist-table tr .sortorder_column {
  width: 125px;
  min-width: 75px;
}
#picklistmenu_fluid table#picklist-table tr .deleted_column {
  width: 55px;
  min-width: 55px;
}
#picklistmenu_fluid table#picklist-menu-table tr .selected_column {
  width: 40px;
  min-width: 40px;
}
#picklistmenu_fluid table#picklist-menu-table tr .picklistname_column {
  width: auto;
  min-width: 125px;
}
#picklistmenu_fluid ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.3);
  border-radius: 10px;
  background-color: #fdfdfd;
}
#picklistmenu_fluid ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
#picklistmenu_fluid ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}
#picklistmenu_fluid ::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}
</style>
